function todayString(): string {
  return new Date().toISOString().slice(0, 10)
}

function addDays(dateStr: string, days: number): string {
  const d = new Date(dateStr)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

export function computeEffectiveStatus(m: {
  status: string
  end_date: string
  grace_days: number
}): 'active' | 'grace' | 'expired' | 'cancelled' | 'suspended' {
  if (m.status === 'cancelled') return 'cancelled'
  if (m.status === 'suspended') return 'suspended'

  const today = todayString()
  const endDateStr = m.end_date.slice(0, 10)

  if (endDateStr >= today) return 'active'

  const graceEndStr = addDays(endDateStr, m.grace_days)
  return graceEndStr >= today ? 'grace' : 'expired'
}

export function graceDaysRemaining(m: {
  end_date: string
  grace_days: number
}): number {
  const today = todayString()
  const graceEndStr = addDays(m.end_date.slice(0, 10), m.grace_days)
  if (graceEndStr < today) return 0
  const ms = new Date(graceEndStr).getTime() - new Date(today).getTime()
  return Math.floor(ms / (1000 * 60 * 60 * 24))
}

export type MembershipTone = 'ok' | 'warn' | 'expired'

export function daysLeft(endDate: string) {
  return Math.ceil((new Date(endDate.slice(0, 10) + 'T12:00:00').getTime() - new Date().setHours(0, 0, 0, 0)) / 86400000)
}

export function membershipMessage(endDate: string | undefined): { message: string; tone: MembershipTone } {
  if (!endDate) return { message: 'Sin membresía activa', tone: 'expired' }
  const days = daysLeft(endDate)
  if (days < 0) return { message: `Vencida hace ${Math.abs(days)} día${Math.abs(days) !== 1 ? 's' : ''}`, tone: 'expired' }
  if (days === 0) return { message: 'Vence hoy', tone: 'warn' }
  if (days <= 7) return { message: `Vence en ${days} día${days !== 1 ? 's' : ''}`, tone: 'warn' }
  return { message: `Al día — vence en ${days} días`, tone: 'ok' }
}
